const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:3001/api';

// Fetch wrapper with timeout and error handling
const fetchWithTimeout = async (url, options = {}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      if (response.status === 401) {
        // Trigger re-authentication
        window.location.reload();
        return;
      }
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Request timeout');
    }
    throw error;
  }
};

export const stockService = {
  // Search for stocks
  searchStocks: async (query) => {
    try {
      return await fetchWithTimeout(`${API_BASE_URL}/search/${query}`);
    } catch (error) {
      console.error('Search error:', error);
      throw new Error(error.message || 'Failed to search stocks');
    }
  },

  // Get current stock quote
  getQuote: async (symbol) => {
    try {
      return await fetchWithTimeout(`${API_BASE_URL}/quote/${symbol}`);
    } catch (error) {
      console.error('Quote error:', error);
      throw new Error(error.message || 'Failed to get stock quote');
    }
  },

  // Get historical data
  getHistoricalData: async (symbol, period = 'daily', range = 'all') => {
    try {
      const baseUrl = `${API_BASE_URL}/history/${symbol}`;
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.append('period', period);
      url.searchParams.append('range', range);
      return await fetchWithTimeout(url.toString());
    } catch (error) {
      console.error('Historical data error:', error);
      throw new Error(error.message || 'Failed to get historical data');
    }
  },

  // Check API health
  checkHealth: async () => {
    try {
      return await fetchWithTimeout(`${API_BASE_URL}/health`);
    } catch (error) {
      console.error('Health check error:', error);
      throw new Error('Backend API is not responding');
    }
  }
};